import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { BidderCommunityMenuService } from '../../../services/bidder-community/bidder-community-menu/bidder-community-menu.service';
import { SearchItemComponent } from "./search-item/search-item.component";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleExclamation, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { PaginatorModule } from 'primeng/paginator';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { MySearchesService } from '../../../services/bidder-community/my-searches/my-searches.service';
import { ISearchesDTO } from '../../../models/ISearchesDTO';
import { ProgressSpinner } from "primeng/progressspinner";
import { ConfirmationService } from 'primeng/api';
import { ToastMessageService } from '../../../services/toast-message/toast-message.service';
import { DialogModule } from "primeng/dialog";
import { Card } from "primeng/card";
import { distinctUntilChanged, Subscription } from 'rxjs';
import { AuthService } from '../../../services/authentication/auth.service';
import { ScrollTopModule } from 'primeng/scrolltop';

@Component({
  selector: 'app-my-searches',
  imports: [
    SearchItemComponent, 
    FaIconComponent, 
    PaginatorModule, 
    CommonModule, 
    TableModule, 
    ProgressSpinner, 
    DialogModule, 
    Card, 
    ScrollTopModule
  ],
  templateUrl: './my-searches.component.html',
  styleUrl: './my-searches.component.scss'
})
export class MySearchesComponent implements OnInit {

  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly mySearchesService = inject(MySearchesService);
  private readonly messageService = inject(ToastMessageService);
  private readonly authService = inject(AuthService);
  
  authSubscription!: Subscription;

  isAuthenticated = this.oidcSecurityService.authenticated;


  faEnvelope = faEnvelope;
  faCircleExclamation = faCircleExclamation;

  mySearchesList: ISearchesDTO[] | null = null;

  paginatedData : ISearchesDTO[] | null = [];

  constructor(private bidderCommunityMenuService: BidderCommunityMenuService, private confirmationService: ConfirmationService){

  }


  first = signal(0);

  @Input() id!: number;

  ngOnInit(): void {
    
    setTimeout(() => {
      this.bidderCommunityMenuService.setPageData(
        {
          id: this.id!,
          pageName: "My Searches",
          pageRoute: "my-searches"
        }
      );
    },100);

    if (typeof window !== 'undefined') {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload();
        }
      };
      if (!this.isAuthenticated().isAuthenticated) {
        window.open(environment.mediaUrl, '_self');
        return;
      }else{
        this.getMySearchesList();
      }
    }

    this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
      if (isAuth) {
        this.getMySearchesList();
      } else {
        if (typeof window !== 'undefined') {
          window.open(environment.mediaUrl, '_self');
        }
        return;
      }
    });

  }

  onPageChange(event: any) {
    this.first.set(event.first);
  }

  getMySearchesList() {
    this.mySearchesService.getMySearches().subscribe(({
      next: () => {
        this.mySearchesList = this.mySearchesService.mySearchesListSignal();
        const next = this.mySearchesList;
        
      },
      error: (err) => {
        console.log('Error retrieve data', err);
      }
    }))
  }

  onDelete(search: ISearchesDTO){
    this.mySearchesService.deleteSearch(search.id).subscribe(({
      next: (result) => {
        this.messageService.success(`Search deleted successfully`);
        this.getMySearchesList();
      },
      error: (err) => {
        this.messageService.error(err || 'unknown error');
      }
    }))
  }

  confirm(search: ISearchesDTO) {
     this.confirmationService.confirm({
            header: 'Delete Search',
            message: 'Are you sure you want to delete this search?',
            accept: () => {
                this.onDelete(search);
            },
            reject: () => {

            },
        });
  }
  

}
